// /* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from 'react';
import { Settings } from '../../../core';
import classnames from 'classnames';

export interface CustomProps {
  tabName: ContentSettingsTabNames;
  tabChangeHandler: (tabName: ContentSettingsTabNames) => void;
  data: Settings;
}

export const ContentSettingsMenu: React.FunctionComponent<CustomProps> = (
  props
) => {
  const [tabName, setTabName] = React.useState<ContentSettingsTabNames>(
    props.tabName || ContentSettingsTabNames.Template
  );
  const setElementActive = (tabValue: ContentSettingsTabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };
  return (
    <div className="col-xl col-lg-3 col-12 bg-gray-100 border-right px-2 py-4 lead-settings-menu">
      <ul className="list-unstyled mb-0 px-0 font-normal font-weight-semibold position-relative lead-settings-list">
        <li>
          <a
            href="javascript:void(0)"
            className={`px-2 py-2 d-flex align-items-center rounded ${
              tabName === ContentSettingsTabNames.Template ? 'active' : ''
            }`}
            onClick={(e) => setElementActive(ContentSettingsTabNames.Template)}
          >
            <span className="col py-1 d-block">Template Settings</span>
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            className={`px-2 py-2 d-flex align-items-center rounded ${
              tabName === ContentSettingsTabNames.District ? 'active' : ''
            }`}
            onClick={(e) => setElementActive(ContentSettingsTabNames.District)}
          >
            <span className="col py-1 d-block"> Districts </span>
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            className={`px-2 py-2 d-flex align-items-center rounded ${
              tabName === ContentSettingsTabNames.Governorate ? 'active' : ''
            }`}
            onClick={(e) =>
              setElementActive(ContentSettingsTabNames.Governorate)
            }
          >
            <span className="col py-1 d-block">Governorate</span>
          </a>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            className={`px-2 py-2 d-flex align-items-center rounded ${
              tabName === ContentSettingsTabNames.Tag ? 'active' : ''
            }`}
            onClick={(e) => setElementActive(ContentSettingsTabNames.Tag)}
          >
            <span className="col py-1 d-block">Tags</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export enum ContentSettingsTabNames {
  Template = 'Template',
  District = 'District',
  Governorate = 'Governorate',
  Tag = 'Tag',
}
